import type { CreateRsvpRequest, CreateRsvpResponse } from '@wix/ambassador-events-v2-rsvp/types'
import { EVENTS_API_PATH_AMBASSADOR } from '../constants'
import { loadAmbassadorEventsV2RsvpHttp, loadAmbassadorWixEventsWebHttp } from '../dynamic-imports'

type GetHeadersCallback = () => HeadersInit

let getRequestHeaders: GetHeadersCallback
let httpClient: {
	request: <T>(
		reqOptionsFactory: (...args: unknown[]) => unknown,
		overrides?: { signedInstance: string }
	) => Promise<{ data: T }>
}

export const prepareEventsApi = (getHeaders: GetHeadersCallback, client: typeof httpClient) => {
	getRequestHeaders = getHeaders
	httpClient = client
}

export const EventsApi = async () => {
	const api = (await loadAmbassadorWixEventsWebHttp()).WixEventsWeb(EVENTS_API_PATH_AMBASSADOR)
	return {
		RsvpManagement: () => ({
			createRsvp: async (request: CreateRsvpRequest): Promise<CreateRsvpResponse> => {
				const { createRsvp } = await loadAmbassadorEventsV2RsvpHttp()
				const { Authorization: signedInstance } = getRequestHeaders() as Record<string, string>
				const { data } = await httpClient.request(createRsvp(request), { signedInstance })
				return data
			},
		}),
		EventManagement: () => api.EventManagement()(getRequestHeaders()),
		CheckoutService: () => api.CheckoutService()(getRequestHeaders()),
	}
}
